import MeasurementCounters from './MeasurementCounters';

export default class TiresSummary {
  newTires = 0;
  hasTiresSwapped = false;
  storageLocation: string | null = null;
  tireMeasurements: MeasurementCounters | null = null;
  brakeMeasurements: MeasurementCounters | null = null;
  isMissingSettings = false;

  getIsEmpty(): boolean {
    return !this.hasTiresSwapped && this.newTires === 0 && this.tireMeasurements === null && this.brakeMeasurements === null;
  }

  updateWith(summary: TiresSummary): void {
    Object.assign(this, summary);
  }
}
